<template>
  <div class="calm__card calm__card--flush">
    <!-- Optional header strip: title/hint on the left, toolbar slot on the right -->
    <div
      v-if="title || hint || $slots.toolbar"
      class="calm__table-head"
    >
      <div class="calm__table-head__main">
        <div v-if="title" class="calm__table-head__title">{{ title }}</div>
        <div v-if="hint" class="calm__table-head__hint">{{ hint }}</div>
      </div>
      <div v-if="$slots.toolbar" class="calm__table-head__tools">
        <slot name="toolbar"></slot>
      </div>
    </div>

    <!-- The table itself. Caller supplies an <el-table> OR a bare
         <table class="calm__table"> — we don't impose a column API. -->
    <div class="calm__table-body">
      <!-- Empty state: shown when not loading and total is 0. -->
      <template v-if="!loading && isEmpty">
        <slot name="empty">
          <div class="calm__empty">
            <div class="c-empty-title">{{ emptyTitle }}</div>
            <div class="c-empty-sub">{{ emptySub }}</div>
          </div>
        </slot>
      </template>
      <template v-else>
        <slot></slot>
      </template>
    </div>

    <!-- Footer: count + per-page + pager. Hidden when empty. -->
    <div v-if="showFooter && !isEmpty" class="calm__tfoot">
      <div class="calm__tfoot__count">
        <slot name="count" :from="from" :to="to" :total="total">
          {{ countLabel }}
          <strong>{{ displayFrom }}</strong>
          {{ toLabel }}
          <strong>{{ to }}</strong>
          {{ ofLabel }}
          <strong>{{ total }}</strong>
        </slot>
      </div>

      <div class="calm__tfoot__per" v-if="perPageOptions && perPageOptions.length">
        <span>{{ perPageLabel }}</span>
        <select
          class="calm__perpage"
          :value="perPage"
          @change="$emit('update:perPage', Number($event.target.value))"
        >
          <option v-for="opt in perPageOptions" :key="opt" :value="opt">
            {{ opt }}
          </option>
        </select>
      </div>

      <base-pagination
        v-if="total > perPage"
        :value="currentPage"
        :per-page="perPage"
        :total="total"
        @input="$emit('update:currentPage', $event)"
      ></base-pagination>
    </div>
  </div>
</template>

<script>
// base-pagination is registered globally (globalComponents.js); the
// .calm__tfoot .pagination rules in calm.scss already skin it.
export default {
  name: "calm-table",
  props: {
    title: { type: String, default: "" },
    hint: { type: String, default: "" },
    total: { type: Number, default: 0 },
    from: { type: Number, default: 0 },     // 0-based offset (clientPaginationMixin.from)
    to: { type: Number, default: 0 },       // exclusive-ish upper bound (mixin.to)
    perPage: { type: Number, default: 10 },
    currentPage: { type: Number, default: 1 },
    perPageOptions: { type: Array, default: () => [5, 10, 25, 50] },
    perPageLabel: { type: String, default: "ต่อหน้า" },
    countLabel: { type: String, default: "แสดง" },
    toLabel: { type: String, default: "ถึง" },
    ofLabel: { type: String, default: "จาก" },
    loading: { type: Boolean, default: false },
    showFooter: { type: Boolean, default: true },
    emptyTitle: { type: String, default: "ไม่พบข้อมูล" },
    emptySub: { type: String, default: "ลองปรับตัวกรองหรือคำค้นหา" },
  },
  computed: {
    isEmpty() {
      return this.total === 0;
    },
    // clientPaginationMixin.from is 0-based; display it 1-based for humans
    displayFrom() {
      return this.total === 0 ? 0 : this.from + 1;
    },
  },
};
</script>
